import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "e61b40c7-1c44-4ca9-ab1b-ea66cefd9b90",
  publicId: "2",
  name: "Signal processing of sound by humans (Signal Processing of human Hearing )",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
